const campaignActionTypes = {
    GET_CAMPAIGN: 'GET_CAMPAIGN',
    UPDATE_CAMPAIGN: 'UPDATE_CAMPAIGN',
    GET_CAMPAIGN_CONFIG: 'GET_CAMPAIGN_CONFIG',
    SET_CAMPAIGN_CONFIG: 'SET_CAMPAIGN_CONFIG',
    SET_DATA: 'SET_DATA',
    IS_EDIT: 'IS_EDIT',
    SET_BOTS: 'SET_BOTS',
    GET_BOTS: 'GET_BOTS',
    IS_CALL_TEST_INBOUND: 'IS_CALL_TEST_INBOUND',
    SERVICE_NUMBERS_CALLED: 'SERVICE_NUMBER',
    SAVE_SERVICE_NUMBER_CALLED: 'SAVE_SERVICE_NUMBER_CALLED',
    RESET_SERVICE_NUMBER_CALLED: 'RESET_SERVICE_NUMBER_CALLED',
    GET_NLUS: 'GET_NLUS',
    SET_NLUS: 'SET_NLUS',
}

export default campaignActionTypes
